import { useState } from 'react'

const useTeams = () => {

    /* ------------------------------------           IRA           ------------------------------- */
    const [Ira, setIra] = useState([[
        { ID: "S1", Name: "UCLA", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Richmond", Out: false, Round: 1 },
        { ID: "S9", Name: "Georgia Tech", Out: false, Round: 2 },
        { ID: "S5", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S12", Name: "Ball St.", Out: false, Round: 1 },
        { ID: "S4", Name: "Baylor", Out: false, Round: 3 },
        { ID: "S13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "S6", Name: "Florida St.", Out: false, Round: 2 },
        { ID: "S11", Name: "George Mason", Out: false, Round: 1 },
        { ID: "S3", Name: "LSU", Out: false, Round: 4 },
        { ID: "S14", Name: "San Diego St.", Out: false, Round: 1 },
        { ID: "S7", Name: "Michigan St.", Out: false, Round: 1 },
        { ID: "S10", Name: "Harvard", Out: false, Round: 2 },
        { ID: "S2", Name: "NC State", Out: false, Round: 3 },
        { ID: "S15", Name: "Vermont", Out: false, Round: 1 },
        { ID: "W1", Name: "Southern California", Out: false, Round: 4 },
        { ID: "W16", Name: "UNC Greensboro", Out: false, Round: 1 },
        { ID: "W8", Name: "California", Out: false, Round: 2 },
        { ID: "W9", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "W5", Name: "Kansas St.", Out: false, Round: 3 },
        { ID: "W12", Name: "Fairfield", Out: false, Round: 1 },
        { ID: "W4", Name: "Kentucky", Out: false, Round: 2 },
        { ID: "W13", Name: "Liberty", Out: false, Round: 1 },
        { ID: "W6", Name: "Iowa", Out: false, Round: 3 },
        { ID: "W11", Name: "Murray St.", Out: false, Round: 1 },
        { ID: "W3", Name: "Oklahoma", Out: false, Round: 2 },
        { ID: "W14", Name: "FGCU", Out: false, Round: 1 },
        { ID: "W7", Name: "Oklahoma St.", Out: false, Round: 2 },
        { ID: "W10", Name: "South Dakota St.", Out: false, Round: 1 },
        { ID: "W2", Name: "UConn", Out: false, Round: 5 },
        { ID: "W15", Name: "Arkansas St.", Out: false, Round: 1 },
        { ID: "E1", Name: "South Carolina", Out: false, Round: 6 },
        { ID: "E16", Name: "Tennessee Tech", Out: false, Round: 1 },
        { ID: "E8", Name: "Utah", Out: false, Round: 2 },
        { ID: "E9", Name: "Indiana", Out: false, Round: 1 },
        { ID: "E5", Name: "Alabama", Out: false, Round: 2 },
        { ID: "E12", Name: "Green Bay", Out: false, Round: 1 },
        { ID: "E4", Name: "Maryland", Out: false, Round: 3 },
        { ID: "E13", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "E6", Name: "West Virginia", Out: false, Round: 2 },
        { ID: "E11", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E3", Name: "North Carolina", Out: false, Round: 4 },
        { ID: "E14", Name: "Oregon St.", Out: false, Round: 1 },
        { ID: "E7", Name: "Vanderbilt", Out: false, Round: 1 },
        { ID: "E10", Name: "Oregon", Out: false, Round: 2 },
        { ID: "E2", Name: "Duke", Out: false, Round: 3 },
        { ID: "E15", Name: "Lehigh", Out: false, Round: 1 },
        { ID: "N1", Name: "Texas", Out: false, Round: 4 },
        { ID: "N16", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N8", Name: "Illinois", Out: false, Round: 1 },
        { ID: "N9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "N5", Name: "Tennessee", Out: false, Round: 2 },
        { ID: "N12", Name: "South Fla.", Out: false, Round: 1 },
        { ID: "N4", Name: "Ohio St.", Out: false, Round: 3 },
        { ID: "N13", Name: "Montana St.", Out: false, Round: 1 },
        { ID: "N6", Name: "Michigan", Out: false, Round: 2 },
        { ID: "N11", Name: "FFN2", Out: false, Round: 1 },
        { ID: "N3", Name: "Notre Dame", Out: false, Round: 5 },
        { ID: "N14", Name: "SFA", Out: false, Round: 1 },
        { ID: "N7", Name: "Louisville", Out: false, Round: 2 },
        { ID: "N10", Name: "Nebraska", Out: false, Round: 1 },
        { ID: "N2", Name: "TCU", Out: false, Round: 3 },
        { ID: "N15", Name: "FDU", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ],
    [
        { ID: "S1", Name: "Auburn", Out: false, Round: 3 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 1 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 5 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 1 },
        { ID: "S13", Name: "Yale", Out: false, Round: 2 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 1 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 3 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 1 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 2 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 4 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 7 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 1 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 2 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 2 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 1 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 3 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 1 },
        { ID: "W11", Name: "Drake", Out: false, Round: 2 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 3 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 1 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 2 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 1 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 4 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 4 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 2 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 2 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 1 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 3 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 2 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 5 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 1 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 2 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 3 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 6 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 2 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 1 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 3 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 1 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 2 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 2 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 4 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 2 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 3 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]]);

    /* ------------------------------------           UNA           ------------------------------- */

    const [Una, setUna] = useState([[
        { ID: "S1", Name: "UCLA", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Richmond", Out: false, Round: 1 },
        { ID: "S9", Name: "Georgia Tech", Out: false, Round: 2 },
        { ID: "S5", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S12", Name: "Ball St.", Out: false, Round: 1 },
        { ID: "S4", Name: "Baylor", Out: false, Round: 3 },
        { ID: "S13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "S6", Name: "Florida St.", Out: false, Round: 2 },
        { ID: "S11", Name: "George Mason", Out: false, Round: 1 },
        { ID: "S3", Name: "LSU", Out: false, Round: 3 },
        { ID: "S14", Name: "San Diego St.", Out: false, Round: 1 },
        { ID: "S7", Name: "Michigan St.", Out: false, Round: 2 },
        { ID: "S10", Name: "Harvard", Out: false, Round: 1 },
        { ID: "S2", Name: "NC State", Out: false, Round: 4 },
        { ID: "S15", Name: "Vermont", Out: false, Round: 1 },
        { ID: "W1", Name: "Southern California", Out: false, Round: 5 },
        { ID: "W16", Name: "UNC Greensboro", Out: false, Round: 1 },
        { ID: "W8", Name: "California", Out: false, Round: 2 },
        { ID: "W9", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "W5", Name: "Kansas St.", Out: false, Round: 2 },
        { ID: "W12", Name: "Fairfield", Out: false, Round: 1 },
        { ID: "W4", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "W13", Name: "Liberty", Out: false, Round: 1 },
        { ID: "W6", Name: "Iowa", Out: false, Round: 2 },
        { ID: "W11", Name: "Murray St.", Out: false, Round: 1 },
        { ID: "W3", Name: "Oklahoma", Out: false, Round: 3 },
        { ID: "W14", Name: "FGCU", Out: false, Round: 1 },
        { ID: "W7", Name: "Oklahoma St.", Out: false, Round: 1 },
        { ID: "W10", Name: "South Dakota St.", Out: false, Round: 2 },
        { ID: "W2", Name: "UConn", Out: false, Round: 4 },
        { ID: "W15", Name: "Arkansas St.", Out: false, Round: 1 },
        { ID: "E1", Name: "South Carolina", Out: false, Round: 6 },
        { ID: "E16", Name: "Tennessee Tech", Out: false, Round: 1 },
        { ID: "E8", Name: "Utah", Out: false, Round: 1 },
        { ID: "E9", Name: "Indiana", Out: false, Round: 2 },
        { ID: "E5", Name: "Alabama", Out: false, Round: 3 },
        { ID: "E12", Name: "Green Bay", Out: false, Round: 1 },
        { ID: "E4", Name: "Maryland", Out: false, Round: 2 },
        { ID: "E13", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "E6", Name: "West Virginia", Out: false, Round: 2 },
        { ID: "E11", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E3", Name: "North Carolina", Out: false, Round: 4 },
        { ID: "E14", Name: "Oregon St.", Out: false, Round: 1 },
        { ID: "E7", Name: "Vanderbilt", Out: false, Round: 1 },
        { ID: "E10", Name: "Oregon", Out: false, Round: 3 },
        { ID: "E2", Name: "Duke", Out: false, Round: 2 },
        { ID: "E15", Name: "Lehigh", Out: false, Round: 1 },
        { ID: "N1", Name: "Texas", Out: false, Round: 3 },
        { ID: "N16", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N8", Name: "Illinois", Out: false, Round: 1 },
        { ID: "N9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "N5", Name: "Tennessee", Out: false, Round: 4 },
        { ID: "N12", Name: "South Fla.", Out: false, Round: 1 },
        { ID: "N4", Name: "Ohio St.", Out: false, Round: 2 },
        { ID: "N13", Name: "Montana St.", Out: false, Round: 1 },
        { ID: "N6", Name: "Michigan", Out: false, Round: 3 },
        { ID: "N11", Name: "FFN2", Out: false, Round: 1 },
        { ID: "N3", Name: "Notre Dame", Out: false, Round: 2 },
        { ID: "N14", Name: "SFA", Out: false, Round: 1 },
        { ID: "N7", Name: "Louisville", Out: false, Round: 2 },
        { ID: "N10", Name: "Nebraska", Out: false, Round: 1 },
        { ID: "N2", Name: "TCU", Out: false, Round: 5 },
        { ID: "N15", Name: "FDU", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ], [
        { ID: "S1", Name: "Auburn", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 1 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 3 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 2 },
        { ID: "S13", Name: "Yale", Out: false, Round: 1 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 1 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 4 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 1 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 2 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 3 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 4 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 1 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 2 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 3 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 1 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 2 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 1 },
        { ID: "W11", Name: "Drake", Out: false, Round: 2 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 5 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 1 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 1 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 3 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 2 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 4 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 2 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 2 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 1 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 3 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 3 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 2 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 2 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 1 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 6 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 5 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 1 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 2 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 3 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 1 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 2 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 3 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 2 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 2 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 4 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]]);

    /* ------------------------------------           AARON           ------------------------------- */

    const [Aaron, setAaron] = useState([[
        { ID: "S1", Name: "UCLA", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Richmond", Out: false, Round: 1 },
        { ID: "S9", Name: "Georgia Tech", Out: false, Round: 2 },
        { ID: "S5", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S12", Name: "Ball St.", Out: false, Round: 1 },
        { ID: "S4", Name: "Baylor", Out: false, Round: 3 },
        { ID: "S13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "S6", Name: "Florida St.", Out: false, Round: 2 },
        { ID: "S11", Name: "George Mason", Out: false, Round: 1 },
        { ID: "S3", Name: "LSU", Out: false, Round: 4 },
        { ID: "S14", Name: "San Diego St.", Out: false, Round: 1 },
        { ID: "S7", Name: "Michigan St.", Out: false, Round: 2 },
        { ID: "S10", Name: "Harvard", Out: false, Round: 1 },
        { ID: "S2", Name: "NC State", Out: false, Round: 3 },
        { ID: "S15", Name: "Vermont", Out: false, Round: 1 },
        { ID: "W1", Name: "Southern California", Out: false, Round: 4 },
        { ID: "W16", Name: "UNC Greensboro", Out: false, Round: 1 },
        { ID: "W8", Name: "California", Out: false, Round: 2 },
        { ID: "W9", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "W5", Name: "Kansas St.", Out: false, Round: 2 },
        { ID: "W12", Name: "Fairfield", Out: false, Round: 1 },
        { ID: "W4", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "W13", Name: "Liberty", Out: false, Round: 1 },
        { ID: "W6", Name: "Iowa", Out: false, Round: 2 },
        { ID: "W11", Name: "Murray St.", Out: false, Round: 1 },
        { ID: "W3", Name: "Oklahoma", Out: false, Round: 3 },
        { ID: "W14", Name: "FGCU", Out: false, Round: 1 },
        { ID: "W7", Name: "Oklahoma St.", Out: false, Round: 2 },
        { ID: "W10", Name: "South Dakota St.", Out: false, Round: 1 },
        { ID: "W2", Name: "UConn", Out: false, Round: 5 },
        { ID: "W15", Name: "Arkansas St.", Out: false, Round: 1 },
        { ID: "E1", Name: "South Carolina", Out: false, Round: 6 },
        { ID: "E16", Name: "Tennessee Tech", Out: false, Round: 1 },
        { ID: "E8", Name: "Utah", Out: false, Round: 2 },
        { ID: "E9", Name: "Indiana", Out: false, Round: 1 },
        { ID: "E5", Name: "Alabama", Out: false, Round: 3 },
        { ID: "E12", Name: "Green Bay", Out: false, Round: 1 },
        { ID: "E4", Name: "Maryland", Out: false, Round: 2 },
        { ID: "E13", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "E6", Name: "West Virginia", Out: false, Round: 3 },
        { ID: "E11", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E3", Name: "North Carolina", Out: false, Round: 2 },
        { ID: "E14", Name: "Oregon St.", Out: false, Round: 1 },
        { ID: "E7", Name: "Vanderbilt", Out: false, Round: 1 },
        { ID: "E10", Name: "Oregon", Out: false, Round: 2 },
        { ID: "E2", Name: "Duke", Out: false, Round: 4 },
        { ID: "E15", Name: "Lehigh", Out: false, Round: 1 },
        { ID: "N1", Name: "Texas", Out: false, Round: 4 },
        { ID: "N16", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N8", Name: "Illinois", Out: false, Round: 2 },
        { ID: "N9", Name: "Creighton", Out: false, Round: 1 },
        { ID: "N5", Name: "Tennessee", Out: false, Round: 2 },
        { ID: "N12", Name: "South Fla.", Out: false, Round: 1 },
        { ID: "N4", Name: "Ohio St.", Out: false, Round: 3 },
        { ID: "N13", Name: "Montana St.", Out: false, Round: 1 },
        { ID: "N6", Name: "Michigan", Out: false, Round: 3 },
        { ID: "N11", Name: "FFN2", Out: false, Round: 1 },
        { ID: "N3", Name: "Notre Dame", Out: false, Round: 2 },
        { ID: "N14", Name: "SFA", Out: false, Round: 1 },
        { ID: "N7", Name: "Louisville", Out: false, Round: 1 },
        { ID: "N10", Name: "Nebraska", Out: false, Round: 2 },
        { ID: "N2", Name: "TCU", Out: false, Round: 5 },
        { ID: "N15", Name: "FDU", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ], [
        { ID: "S1", Name: "Auburn", Out: false, Round: 3 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 2 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 1 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 4 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 2 },
        { ID: "S13", Name: "Yale", Out: false, Round: 1 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 1 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 3 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 2 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 1 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 6 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 5 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 2 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 1 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 2 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 1 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 3 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 2 },
        { ID: "W11", Name: "Drake", Out: false, Round: 1 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 3 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 1 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 1 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 4 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 2 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 3 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 2 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 1 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 4 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 1 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 2 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 3 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 2 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 1 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 2 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 5 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 2 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 1 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 5 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 2 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 1 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 3 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 2 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 7 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 3 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 2 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]]);


    /* ------------------------------------           CONNOR           ------------------------------- */

    const [Connor, setConnor] = useState([[
        { ID: "S1", Name: "UCLA", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Richmond", Out: false, Round: 2 },
        { ID: "S9", Name: "Georgia Tech", Out: false, Round: 1 },
        { ID: "S5", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S12", Name: "Ball St.", Out: false, Round: 1 },
        { ID: "S4", Name: "Baylor", Out: false, Round: 1 },
        { ID: "S13", Name: "Grand Canyon", Out: false, Round: 3 },
        { ID: "S6", Name: "Florida St.", Out: false, Round: 2 },
        { ID: "S11", Name: "George Mason", Out: false, Round: 1 },
        { ID: "S3", Name: "LSU", Out: false, Round: 4 },
        { ID: "S14", Name: "San Diego St.", Out: false, Round: 1 },
        { ID: "S7", Name: "Michigan St.", Out: false, Round: 1 },
        { ID: "S10", Name: "Harvard", Out: false, Round: 2 },
        { ID: "S2", Name: "NC State", Out: false, Round: 3 },
        { ID: "S15", Name: "Vermont", Out: false, Round: 1 },
        { ID: "W1", Name: "Southern California", Out: false, Round: 4 },
        { ID: "W16", Name: "UNC Greensboro", Out: false, Round: 1 },
        { ID: "W8", Name: "California", Out: false, Round: 2 },
        { ID: "W9", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "W5", Name: "Kansas St.", Out: false, Round: 1 },
        { ID: "W12", Name: "Fairfield", Out: false, Round: 2 },
        { ID: "W4", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "W13", Name: "Liberty", Out: false, Round: 1 },
        { ID: "W6", Name: "Iowa", Out: false, Round: 3 },
        { ID: "W11", Name: "Murray St.", Out: false, Round: 1 },
        { ID: "W3", Name: "Oklahoma", Out: false, Round: 2 },
        { ID: "W14", Name: "FGCU", Out: false, Round: 1 },
        { ID: "W7", Name: "Oklahoma St.", Out: false, Round: 2 },
        { ID: "W10", Name: "South Dakota St.", Out: false, Round: 1 },
        { ID: "W2", Name: "UConn", Out: false, Round: 5 },
        { ID: "W15", Name: "Arkansas St.", Out: false, Round: 1 },
        { ID: "E1", Name: "South Carolina", Out: false, Round: 6 },
        { ID: "E16", Name: "Tennessee Tech", Out: false, Round: 1 },
        { ID: "E8", Name: "Utah", Out: false, Round: 2 },
        { ID: "E9", Name: "Indiana", Out: false, Round: 1 },
        { ID: "E5", Name: "Alabama", Out: false, Round: 3 },
        { ID: "E12", Name: "Green Bay", Out: false, Round: 1 },
        { ID: "E4", Name: "Maryland", Out: false, Round: 2 },
        { ID: "E13", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "E6", Name: "West Virginia", Out: false, Round: 3 },
        { ID: "E11", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E3", Name: "North Carolina", Out: false, Round: 12 },
        { ID: "E14", Name: "Oregon St.", Out: false, Round: 1 },
        { ID: "E7", Name: "Vanderbilt", Out: false, Round: 4 },
        { ID: "E10", Name: "Oregon", Out: false, Round: 1 },
        { ID: "E2", Name: "Duke", Out: false, Round: 2 },
        { ID: "E15", Name: "Lehigh", Out: false, Round: 1 },
        { ID: "N1", Name: "Texas", Out: false, Round: 4 },
        { ID: "N16", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N8", Name: "Illinois", Out: false, Round: 2 },
        { ID: "N9", Name: "Creighton", Out: false, Round: 1 },
        { ID: "N5", Name: "Tennessee", Out: false, Round: 3 },
        { ID: "N12", Name: "South Fla.", Out: false, Round: 1 },
        { ID: "N4", Name: "Ohio St.", Out: false, Round: 2 },
        { ID: "N13", Name: "Montana St.", Out: false, Round: 1 },
        { ID: "N6", Name: "Michigan", Out: false, Round: 2 },
        { ID: "N11", Name: "FFN2", Out: false, Round: 1 },
        { ID: "N3", Name: "Notre Dame", Out: false, Round: 5 },
        { ID: "N14", Name: "SFA", Out: false, Round: 1 },
        { ID: "N7", Name: "Louisville", Out: false, Round: 2 },
        { ID: "N10", Name: "Nebraska", Out: false, Round: 1 },
        { ID: "N2", Name: "TCU", Out: false, Round: 3 },
        { ID: "N15", Name: "FDU", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ], [
        { ID: "S1", Name: "Auburn", Out: false, Round: 3 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 2 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 1 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 5 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 1 },
        { ID: "S13", Name: "Yale", Out: false, Round: 2 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 1 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 3 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 2 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 1 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 2 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 4 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 7 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 2 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 1 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 2 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 1 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 3 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 1 },
        { ID: "W11", Name: "Drake", Out: false, Round: 2 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 4 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 1 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 2 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 1 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 3 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 6 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 2 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 3 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 1 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 2 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 3 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 2 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 2 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 1 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 4 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 3 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 2 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 1 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 1 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 2 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 4 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 3 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 2 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 2 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 5 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]]);

    /* ------------------------------------           SABRINA           ------------------------------- */

    const [Sabrina, setSabrina] = useState([[
        { ID: "S1", Name: "UCLA", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Richmond", Out: false, Round: 2 },
        { ID: "S9", Name: "Georgia Tech", Out: false, Round: 1 },
        { ID: "S5", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S12", Name: "Ball St.", Out: false, Round: 1 },
        { ID: "S4", Name: "Baylor", Out: false, Round: 3 },
        { ID: "S13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "S6", Name: "Florida St.", Out: false, Round: 2 },
        { ID: "S11", Name: "George Mason", Out: false, Round: 1 },
        { ID: "S3", Name: "LSU", Out: false, Round: 4 },
        { ID: "S14", Name: "San Diego St.", Out: false, Round: 1 },
        { ID: "S7", Name: "Michigan St.", Out: false, Round: 2 },
        { ID: "S10", Name: "Harvard", Out: false, Round: 1 },
        { ID: "S2", Name: "NC State", Out: false, Round: 3 },
        { ID: "S15", Name: "Vermont", Out: false, Round: 1 },
        { ID: "W1", Name: "Southern California", Out: false, Round: 5 },
        { ID: "W16", Name: "UNC Greensboro", Out: false, Round: 1 },
        { ID: "W8", Name: "California", Out: false, Round: 1 },
        { ID: "W9", Name: "Mississippi St.", Out: false, Round: 2 },
        { ID: "W5", Name: "Kansas St.", Out: false, Round: 2 },
        { ID: "W12", Name: "Fairfield", Out: false, Round: 1 },
        { ID: "W4", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "W13", Name: "Liberty", Out: false, Round: 1 },
        { ID: "W6", Name: "Iowa", Out: false, Round: 2 },
        { ID: "W11", Name: "Murray St.", Out: false, Round: 1 },
        { ID: "W3", Name: "Oklahoma", Out: false, Round: 3 },
        { ID: "W14", Name: "FGCU", Out: false, Round: 1 },
        { ID: "W7", Name: "Oklahoma St.", Out: false, Round: 3 },
        { ID: "W10", Name: "South Dakota St.", Out: false, Round: 1 },
        { ID: "W2", Name: "UConn", Out: false, Round: 4 },
        { ID: "W15", Name: "Arkansas St.", Out: false, Round: 1 },
        { ID: "E1", Name: "South Carolina", Out: false, Round: 6 },
        { ID: "E16", Name: "Tennessee Tech", Out: false, Round: 1 },
        { ID: "E8", Name: "Utah", Out: false, Round: 1 },
        { ID: "E9", Name: "Indiana", Out: false, Round: 2 },
        { ID: "E5", Name: "Alabama", Out: false, Round: 5 },
        { ID: "E12", Name: "Green Bay", Out: false, Round: 1 },
        { ID: "E4", Name: "Maryland", Out: false, Round: 3 },
        { ID: "E13", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "E6", Name: "West Virginia", Out: false, Round: 2 },
        { ID: "E11", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E3", Name: "North Carolina", Out: false, Round: 3 },
        { ID: "E14", Name: "Oregon St.", Out: false, Round: 1 },
        { ID: "E7", Name: "Vanderbilt", Out: false, Round: 2 },
        { ID: "E10", Name: "Oregon", Out: false, Round: 1 },
        { ID: "E2", Name: "Duke", Out: false, Round: 4 },
        { ID: "E15", Name: "Lehigh", Out: false, Round: 1 },
        { ID: "N1", Name: "Texas", Out: false, Round: 5 },
        { ID: "N16", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N8", Name: "Illinois", Out: false, Round: 2 },
        { ID: "N9", Name: "Creighton", Out: false, Round: 1 },
        { ID: "N5", Name: "Tennessee", Out: false, Round: 2 },
        { ID: "N12", Name: "South Fla.", Out: false, Round: 2 },
        { ID: "N4", Name: "Ohio St.", Out: false, Round: 3 },
        { ID: "N13", Name: "Montana St.", Out: false, Round: 1 },
        { ID: "N6", Name: "Michigan", Out: false, Round: 2 },
        { ID: "N11", Name: "FFN2", Out: false, Round: 1 },
        { ID: "N3", Name: "Notre Dame", Out: false, Round: 4 },
        { ID: "N14", Name: "SFA", Out: false, Round: 1 },
        { ID: "N7", Name: "Louisville", Out: false, Round: 2 },
        { ID: "N10", Name: "Nebraska", Out: false, Round: 1 },
        { ID: "N2", Name: "TCU", Out: false, Round: 3 },
        { ID: "N15", Name: "FDU", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ], [
        { ID: "S1", Name: "Auburn", Out: false, Round: 6 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 1 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 2 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 3 },
        { ID: "S13", Name: "Yale", Out: false, Round: 1 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 1 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 4 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 1 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 2 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 3 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 2 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 3 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 1 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 2 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 1 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 5 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 2 },
        { ID: "W11", Name: "Drake", Out: false, Round: 1 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 3 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 1 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 2 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 1 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 6 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 7 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 2 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 2 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 1 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 3 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 3 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 2 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 1 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 2 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 4 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 5 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 2 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 1 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 2 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 1 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 3 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 2 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 2 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 6 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]]);

    /* ------------------------------------           SABRINA           ------------------------------- */

    const [Kai, setKai] = useState([[
        { ID: "S1", Name: "UCLA", Out: false, Round: 4 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Richmond", Out: false, Round: 2 },
        { ID: "S9", Name: "Georgia Tech", Out: false, Round: 1 },
        { ID: "S5", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S12", Name: "Ball St.", Out: false, Round: 1 },
        { ID: "S4", Name: "Baylor", Out: false, Round: 3 },
        { ID: "S13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "S6", Name: "Florida St.", Out: false, Round: 5 },
        { ID: "S11", Name: "George Mason", Out: false, Round: 1 },
        { ID: "S3", Name: "LSU", Out: false, Round: 2 },
        { ID: "S14", Name: "San Diego St.", Out: false, Round: 1 },
        { ID: "S7", Name: "Michigan St.", Out: false, Round: 2 },
        { ID: "S10", Name: "Harvard", Out: false, Round: 1 },
        { ID: "S2", Name: "NC State", Out: false, Round: 3 },
        { ID: "S15", Name: "Vermont", Out: false, Round: 1 },
        { ID: "W1", Name: "Southern California", Out: false, Round: 4 },
        { ID: "W16", Name: "UNC Greensboro", Out: false, Round: 1 },
        { ID: "W8", Name: "California", Out: false, Round: 2 },
        { ID: "W9", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "W5", Name: "Kansas St.", Out: false, Round: 2 },
        { ID: "W12", Name: "Fairfield", Out: false, Round: 1 },
        { ID: "W4", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "W13", Name: "Liberty", Out: false, Round: 1 },
        { ID: "W6", Name: "Iowa", Out: false, Round: 1 },
        { ID: "W11", Name: "Murray St.", Out: false, Round: 3 },
        { ID: "W3", Name: "Oklahoma", Out: false, Round: 2 },
        { ID: "W14", Name: "FGCU", Out: false, Round: 1 },
        { ID: "W7", Name: "Oklahoma St.", Out: false, Round: 2 },
        { ID: "W10", Name: "South Dakota St.", Out: false, Round: 1 },
        { ID: "W2", Name: "UConn", Out: false, Round: 7 },
        { ID: "W15", Name: "Arkansas St.", Out: false, Round: 1 },
        { ID: "E1", Name: "South Carolina", Out: false, Round: 5 },
        { ID: "E16", Name: "Tennessee Tech", Out: false, Round: 1 },
        { ID: "E8", Name: "Utah", Out: false, Round: 2 },
        { ID: "E9", Name: "Indiana", Out: false, Round: 1 },
        { ID: "E5", Name: "Alabama", Out: false, Round: 3 },
        { ID: "E12", Name: "Green Bay", Out: false, Round: 1 },
        { ID: "E4", Name: "Maryland", Out: false, Round: 2 },
        { ID: "E13", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "E6", Name: "West Virginia", Out: false, Round: 1 },
        { ID: "E11", Name: "FFE1", Out: false, Round: 3 },
        { ID: "E3", Name: "North Carolina", Out: false, Round: 2 },
        { ID: "E14", Name: "Oregon St.", Out: false, Round: 1 },
        { ID: "E7", Name: "Vanderbilt", Out: false, Round: 2 },
        { ID: "E10", Name: "Oregon", Out: false, Round: 1 },
        { ID: "E2", Name: "Duke", Out: false, Round: 4 },
        { ID: "E15", Name: "Lehigh", Out: false, Round: 1 },
        { ID: "N1", Name: "Texas", Out: false, Round: 3 },
        { ID: "N16", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N8", Name: "Illinois", Out: false, Round: 1 },
        { ID: "N9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "N5", Name: "Tennessee", Out: false, Round: 4 },
        { ID: "N12", Name: "South Fla.", Out: false, Round: 1 },
        { ID: "N4", Name: "Ohio St.", Out: false, Round: 2 },
        { ID: "N13", Name: "Montana St.", Out: false, Round: 1 },
        { ID: "N6", Name: "Michigan", Out: false, Round: 1 },
        { ID: "N11", Name: "FFN2", Out: false, Round: 2 },
        { ID: "N3", Name: "Notre Dame", Out: false, Round: 3 },
        { ID: "N14", Name: "SFA", Out: false, Round: 1 },
        { ID: "N7", Name: "Louisville", Out: false, Round: 1 },
        { ID: "N10", Name: "Nebraska", Out: false, Round: 2 },
        { ID: "N2", Name: "TCU", Out: false, Round: 6 },
        { ID: "N15", Name: "FDU", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ], [
        { ID: "S1", Name: "Auburn", Out: false, Round: 5 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 2 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 1 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 3 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 1 },
        { ID: "S13", Name: "Yale", Out: false, Round: 2 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 2 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 1 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 4 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 1 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 3 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 2 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 6 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 2 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 1 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 2 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 1 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 3 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 2 },
        { ID: "W11", Name: "Drake", Out: false, Round: 1 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 3 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 1 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 1 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 2 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 4 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 7 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 2 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 2 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 1 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 3 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 2 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 3 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 1 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 2 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 4 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 4 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 2 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 1 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 3 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 1 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 2 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 3 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 1 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 2 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 2 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 5 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]]);

    let [teams, setTeams] = useState([
        { ID: "S1", Name: "Auburn", Out: false, Round: 7 },
        { ID: "S16", Name: "FFS1", Out: false, Round: 1 },
        { ID: "S8", Name: "Louisville", Out: false, Round: 1 },
        { ID: "S9", Name: "Creighton", Out: false, Round: 2 },
        { ID: "S5", Name: "Michigan", Out: false, Round: 3 },
        { ID: "S12", Name: "UC San Diego", Out: false, Round: 1 },
        { ID: "S4", Name: "Texas A&M", Out: false, Round: 1 },
        { ID: "S13", Name: "Yale", Out: false, Round: 2 },
        { ID: "S6", Name: "Ole Miss", Out: false, Round: 1 },
        { ID: "S11", Name: "FFS2", Out: false, Round: 2 },
        { ID: "S3", Name: "Iowa St.", Out: false, Round: 4 },
        { ID: "S14", Name: "Lipscomb", Out: false, Round: 1 },
        { ID: "S7", Name: "Marquette", Out: false, Round: 2 },
        { ID: "S10", Name: "New Mexico", Out: false, Round: 1 },
        { ID: "S2", Name: "Michigan St.", Out: false, Round: 3 },
        { ID: "S15", Name: "Bryant", Out: false, Round: 1 },
        { ID: "W1", Name: "Florida", Out: false, Round: 3 },
        { ID: "W16", Name: "Norfolk St.", Out: false, Round: 1 },
        { ID: "W8", Name: "UConn", Out: false, Round: 1 },
        { ID: "W9", Name: "Oklahoma", Out: false, Round: 2 },
        { ID: "W5", Name: "Memphis", Out: false, Round: 1 },
        { ID: "W12", Name: "Colorado St.", Out: false, Round: 2 },
        { ID: "W4", Name: "Maryland", Out: false, Round: 4 },
        { ID: "W13", Name: "Grand Canyon", Out: false, Round: 1 },
        { ID: "W6", Name: "Missouri", Out: false, Round: 1 },
        { ID: "W11", Name: "Drake", Out: false, Round: 5 },
        { ID: "W3", Name: "Texas Tech", Out: false, Round: 1 },
        { ID: "W14", Name: "UNC Wilmington", Out: false, Round: 2 },
        { ID: "W7", Name: "Kansas", Out: false, Round: 1 },
        { ID: "W10", Name: "Arkansas", Out: false, Round: 2 },
        { ID: "W2", Name: "Saint John's", Out: false, Round: 3 },
        { ID: "W15", Name: "Omaha", Out: false, Round: 1 },
        { ID: "E1", Name: "Duke", Out: false, Round: 3 },
        { ID: "E16", Name: "FFE1", Out: false, Round: 1 },
        { ID: "E8", Name: "Mississippi St.", Out: false, Round: 1 },
        { ID: "E9", Name: "Baylor", Out: false, Round: 2 },
        { ID: "E5", Name: "Oregon", Out: false, Round: 1 },
        { ID: "E12", Name: "Liberty", Out: false, Round: 2 },
        { ID: "E4", Name: "Arizona", Out: false, Round: 5 },
        { ID: "E13", Name: "Akron", Out: false, Round: 1 },
        { ID: "E6", Name: "BYU", Out: false, Round: 4 },
        { ID: "E11", Name: "VCU", Out: false, Round: 1 },
        { ID: "E3", Name: "Wisconsin", Out: false, Round: 2 },
        { ID: "E14", Name: "Montana", Out: false, Round: 1 },
        { ID: "E7", Name: "Saint Mary's", Out: false, Round: 2 },
        { ID: "E10", Name: "Vanderbilt", Out: false, Round: 1 },
        { ID: "E2", Name: "Alabama", Out: false, Round: 3 },
        { ID: "E15", Name: "Robert Morris", Out: false, Round: 1 },
        { ID: "N1", Name: "Houston", Out: false, Round: 6 },
        { ID: "N16", Name: "SIU Edwardsville", Out: false, Round: 1 },
        { ID: "N8", Name: "Gonzaga", Out: false, Round: 2 },
        { ID: "N9", Name: "Georgia", Out: false, Round: 1 },
        { ID: "N5", Name: "Clemson", Out: false, Round: 3 },
        { ID: "N12", Name: "McNeese", Out: false, Round: 1 },
        { ID: "N4", Name: "Purdue", Out: false, Round: 2 },
        { ID: "N13", Name: "High Point", Out: false, Round: 1 },
        { ID: "N6", Name: "Illinois", Out: false, Round: 1 },
        { ID: "N11", Name: "FFN1", Out: false, Round: 2 },
        { ID: "N3", Name: "Kentucky", Out: false, Round: 3 },
        { ID: "N14", Name: "Troy", Out: false, Round: 1 },
        { ID: "N7", Name: "UCLA", Out: false, Round: 2 },
        { ID: "N10", Name: "Utah St.", Out: false, Round: 1 },
        { ID: "N2", Name: "Tennessee", Out: false, Round: 4 },
        { ID: "N15", Name: "Wofford", Out: false, Round: 1 },
        { ID: "00", Name: "SOUTH", Out: true, Round: 0 },
        { ID: "00", Name: "WEST", Out: true, Round: 0 },
        { ID: "00", Name: "EAST", Out: true, Round: 0 },
        { ID: "00", Name: "MIDWEST", Out: true, Round: 0 },
        { ID: "00", Name: "South Seed", Out: true, Round: 0 },
        { ID: "00", Name: "West Seed", Out: true, Round: 0 },
        { ID: "00", Name: "East Seed", Out: true, Round: 0 },
        { ID: "00", Name: "Midwest Seed", Out: true, Round: 0 },
    ]);

    return { teams, setTeams, Ira, Kai, Sabrina, Connor, Una, Aaron }
}

export default useTeams;